import * as Sentry from '@sentry/browser'

import { showInstallPromotion } from '../components/InstallPromotion'
import { toast } from '../components/message'
import {
  buscaProdutos,
  checkCameraPermission,
  conectarSocketOlivo,
  confirmarPedido,
  exibeQrCodePIX,
  showButtonOrder,
  storeOrder,
} from '../mobile'
import {
  criaIdentificadorUsuarioQRCode,
  validaSessaoQRCode,
} from '../Modules/qrCode'
import { configuraProgramaFidelidade } from '../pages/ProgramaDeFidelidade/ProgramaDeFidelidade'
import { usuario } from '../usuario'
import {
  createElement,
  format,
  getUrlAction,
  sentryError,
  storage,
} from '../utils'
import { BuscaDadosEstabelecimento } from './components/DadosEstabelecimento'
import { getStatusEstabelecimento } from './components/StatusAbertura'

let estabelecimento = {
  dispositivo: window.navigator?.userAgent,
  idSocket: '',
  tituloDestaques: 'Destaques',
  sugestoesProdutos: [],
  agendamento: {
    ativo: false,
    intervalo: 0,
    somenteAgendamentos: false,
  },
  plano: {
    basico: false,
    itermediario: false,
    avancado: false,
  },
  faixamesa: '',
  fantasia: '',
  logo: '',
  qrCode: {
    ativo: false,
    apenasVisualizacao: false,
    modoSenha: false,
    nomeCliente: '',
    celularCliente: '',
    horasSessaoQRCode: 5,
    mesa: '',
    solicitaInformacoesClienteQRCode: false,
    obrigarLeituraDaComanda: false,
    modoTablet: false,
    acessoCamera: false,
  },
  cardapio: {
    visualizacao: false,
  },
  endereco: {
    coordenadas: '',
    bairro: '',
    logradouro: '',
    numero: '',
    cidade: '',
    estado: '',

    toString: () => {
      const enderecoValues = [
        estabelecimento.endereco.logradouro,
        estabelecimento.endereco.numero,
        estabelecimento.endereco.bairro,
        estabelecimento.endereco.cidade,
        estabelecimento.endereco.estado,
      ].filter((item) => item)

      return enderecoValues.join(',')
    },
  },
  urlServer: '',
  pagamento: {
    somenteDinheiro: false,
    metodos: [],
    online: false,
    toString: () => {
      let formasDePagamento = ''
      estabelecimento.pagamento.metodos.forEach((pagamento, index, array) => {
        if (pagamento.Descricao) {
          formasDePagamento += pagamento.Descricao
          if (index + 1 !== array.length) {
            formasDePagamento += ', '
          }
        }
      })
      return formasDePagamento
    },
  },
  intervaloProdutos: {
    ativo: false,
    intervalos: [],
    intervalosPromocao: [],
  },
  chavepix: '',

  pizza: {
    considerarSaborComValorMaior: false,
    pizzas: [],
  },
  valorMinimoPedido: 0,
  semTaxaEntrega: false,
  contato: {
    email: '',
    twitter: '',
    site: '',
    telefone: '',
    instagram: '',
    facebook: '',
  },
  descricaoTempoEntrega: '',
  tempoEntrega: '',
  informarcao: '',
  entrega: {
    tempoRetirada: 0,
    somenteEntregaBalcao: false,
    bairros: [],
    TemPedidoMinimoPorBairro: false,
    percentualTaxaEntrega: 0,
  },
  urlEmpresa: storage.get('urlEmpresa'),
  codigoBuscaBalcao: '',
  aberto: false,
  qrCodeAberto: false,
  mesa: '',
  comanda: {
    ativo: false,
    numero: '',
    utilizada: false,
    hash: '',
    hashLocal: '',
    hashAutorizado: '',
    QRCodeComandaModoSeguranca: false,
  },
  horarios: [],
  diasAbertos: [],
  programaFidelidade: {
    Descricao: '',
    PontosGanhos: 0,
    PontosUtilizados: 0,
    TipoLancamentoDesconto: 0,
    ValorGanho: 0,
    ValorGasto: 0,
    cliente: {
      pontos: 0,
    },
  },
  offline: false,
  deliveryAutomatico: false,
  confirmarPedido: false,
  taxaDeServico: 0,
  pixelFacebook: '',
  tipoEntrega: '',
  api: {
    maps: '',
    geocoder: '',
  },
  naoExibeCampoObsProdutoQRCode: false,
  naoExibeCampoObsProdutoDelivery: false,
  validaEstoque: false,
  ip: '',
  chaveAPIGoogleMaps: '',
  idSocket: '',
}

function inicializaEstabelecimento() {
  BuscaDadosEstabelecimento()
}

// @ts-ignore
if (window.urlEstabelecimento) {
  // @ts-ignore
  estabelecimento.urlEmpresa = window.urlEstabelecimento
}

inicializaEstabelecimento()

axios
  .get(getUrlAction('Home', 'BuscaDadosEstab'), {
    params: {
      urlEmpresa: estabelecimento.urlEmpresa,
    },
  })
  .then(function ({ data }) {
    estabelecimento = { ...estabelecimento, ...data }

    {
      if (isDebug) {
        window.estabelecimento = estabelecimento
        window.usuario = usuario
      }
    }

    defineTempoEntrega()

    defineRedesSociais(data)

    removeLoaderApp()

    // Endereço
    if (data.Bairro) {
      estabelecimento.endereco.bairro = data.Bairro.Descricao
    }
    estabelecimento.endereco.logradouro = data.Logradouro
    estabelecimento.endereco.numero = data.Numero
    estabelecimento.endereco.cidade = data.cidade
    estabelecimento.endereco.estado = data.estado
    estabelecimento.endereco.coordenadas = data.Cordenadas
    // Fim Endereço

    configuraCabecalhoEstabelecimento()

    estabelecimento.pizza.considerarSaborComValorMaior =
      data.considerarSaborComValorMaior

    carregaPedidoLocalStorage()

    // Com a logo e o nome do estabelecimento carregado, exibe a mensagem de instalação
    if (!estabelecimento.qrCode.ativo) {
      showInstallPromotion()
    }

    estabelecimento.cardapio.visualizacao =
      data.CardapioDeliveryReadOnly ||
      location.origin.includes('cardapio.mogomenu') ||
      verificaCardapioLeitura() || localStorage.getItem('somenteVisualizacao')

    localStorage.removeItem('somenteVisualizacao')
    if (estabelecimento.cardapio.visualizacao) {
      document.body.classList.add('cardapio-visualizacao')
      estabelecimento.qrCode.ativo = true
      window.configuracoesCardapio = {}


    }

    estabelecimento.pagamento.online = data.IsPagamentoOnline

    estabelecimento.entrega.somenteEntregaBalcao = data.SomenteEntregaBalcao
    estabelecimento.entrega.tempoRetirada = data.TempoRetirada

    estabelecimento.qrCode.apenasVisualizacao = data.CardapioDeliveryReadOnly
    estabelecimento.qrCode.apenasVisualizacao &&
      estabelecimento.qrCode.ativo && document.body.classList.add('qrcode-visualizacao')

    estabelecimento.qrCode.modoTablet = window.location.href.includes('tablet')

    estabelecimento.comanda.QRCodeComandaModoSeguranca =
      data.QRCodeComandaModoSeguranca

    estabelecimento.qrCode.horasSessaoQRCode =
      data.HorasSessaoQRCode == 0 ? 5 : data.HorasSessaoQRCode
    estabelecimento.qrCode.solicitaInformacoesClienteQRCode =
      data.SolicitaInformacoesClienteQRCode
    estabelecimento.qrCode.obrigarLeituraDaComanda = data.ObrigarLeituraDaComanda

    estabelecimento.chaveAPIGoogleMaps = data.ChaveAPIGoogleMaps

    estabelecimento.tipoEntrega = verificaTipoEntrega(data.TipoTaxaEntrega)

    window.estabelecimentoCarregado = true

    estabelecimento.validaEstoque = data.validaEstoqueCardapio

    estabelecimento.entrega.percentualTaxaEntrega = data.PercentualTaxaEntrega

    configuraCardapio()

    if (typeof window.awaitCarregaEnderecos === 'function') {
      window.awaitCarregaEnderecos()
    }
    getStatusEstabelecimento()

    if (estabelecimento.qrCode.ativo) {
      const logoMenu = select('.logo-mesa')
      if (logoMenu) {
        logoMenu.setAttribute('src', estabelecimento.logo)
      }
    }

    exibeMensagemTax()

    if (!estabelecimento.DeliveryOffline) {
      configuraProgramaFidelidade()
    }

    configuraQRCode()

    configuraFacebookPixel()

  })
  .catch(function (error) {
    Sentry.captureException(error)
  })

const urlMarketPlace = storage.get('urlMarketPlace')

function verificaTipoEntrega(id) {
  if (id == 0) {
    return 'bairro'
  } else if (id == 1) {
    return 'raio'
  } else {
    return 'distancia'
  }
}
configuraCardapio()
function configuraCardapio() {
  try {
    const isQRCode = typeof configuracoesCardapio === 'object'

    if (isQRCode) {
      estabelecimento.qrCode.ativo = true
    }

    let configuracoesStorage = storage.get('configuracoes-qrcode')

    // Caso não encontre no localStorage (problemas de privacidade), busca no sessionStorage
    if (!configuracoesStorage) {
      configuracoesStorage = storage.get('configuracoes-qrcode')
    }

    if (configuracoesStorage) {
      if (configuracoesStorage.empresa != estabelecimento.urlEmpresa) {
        storage.remove('configuracoes-qrcode')
        configuracoesStorage = null
      }
    }

    if (estabelecimento.qrCode.ativo) {
      document.body.classList.add('cardapio-digital')

      // Salva nos dois storages caso o navegador não permita salvar no localStorage por privacidade
      localStorage.setItem(
        'configuracoes-qrcode',
        JSON.stringify(configuracoesCardapio),
      )
      sessionStorage.setItem(
        'configuracoes-qrcode',
        JSON.stringify(configuracoesCardapio),
      )

      if (configuracoesCardapio.tipo == 'visualizacao' || (estabelecimento.qrCode.ativo && urlEstabelecimento == "telepub") || (estabelecimento.qrCode.ativo && urlEstabelecimento == "bierdamm")) {
        configuracoesCardapio.tipo = 'visualizacao'
        document.body.classList.add('qrcode-visualizacao')
        return
      }

      estabelecimento.comanda.numero = configuracoesCardapio.comanda
      estabelecimento.mesa = configuracoesCardapio.mesa
      estabelecimento.qrCode.modoSenha = configuracoesCardapio.tipo == 'senha'
      estabelecimento.comanda.ativo = configuracoesCardapio.tipo == 'comanda'

      const title = select('.mesa-container h1')
      const botaoSairQRCode = select('#menu-sair-QRcode')

      if (botaoSairQRCode) {
        botaoSairQRCode.addEventListener('click', () => {
          window.localStorage.removeItem('configuracoes-qrcode')
          window.sessionStorage.removeItem('configuracoes-qrcode')
          window.location =
            window.location.origin + '/' + estabelecimento.urlEmpresa
        })
      }

      if (estabelecimento.qrCode.modoSenha) {
        title.textContent = estabelecimento.fantasia
        botaoSairQRCode.remove()
      } else if (estabelecimento.comanda.ativo) {
        title.textContent = 'Comanda ' + estabelecimento.comanda.numero
      } else {
        title.textContent = 'Mesa ' + estabelecimento.mesa
      }

      usuario.identificadorQRCode = criaIdentificadorUsuarioQRCode()
    } else if (configuracoesStorage) {
      validaSessaoQRCode(configuracoesStorage.ticks, estabelecimento)

      // Se após validar foi ativado o modo QRCode
      if (estabelecimento.qrCode.ativo) {
        configuracoesCardapio = configuracoesStorage
        configuraCardapio()
      }
      return
    }
    const marketplaceButton = select('#marketplace')
    if (!estabelecimento.qrCode.modoSenha) {
      if (marketplaceButton) {
        marketplaceButton.remove()
      }

      window.onbeforeunload = function (event) {
        if (!select('#message-box-login') && !select('.mensagem-login')) {
          event.returnValue = 'Tem certeza que deseja sair da página?'
        }
      }
    } else {
      if (marketplaceButton) {
        marketplaceButton.style.display = 'flex'

        marketplaceButton.addEventListener('click', () => {
          window.location.href =
            location.origin +
            `/home/marketplace?urlMarketPlace=${urlMarketPlace}`
        })
      }
    }

    if (
      estabelecimento.comanda.ativo &&
      estabelecimento.comanda.QRCodeComandaModoSeguranca
    ) {
      const configuracoesComanda = configuracoesCardapio.hashComanda
      if (configuracoesComanda) {
        const parsedConfig =
          typeof configuracoesComanda === 'string'
            ? JSON.parse(configuracoesComanda)
            : configuracoesComanda
        setConfig(parsedConfig)
        localStorage.removeItem('HashComanda')
      } else {
        axios
          .get(getUrlAction('Home', 'ConsultaComanda'), {
            params: {
              urlEmpresa: estabelecimento.urlEmpresa,
              strComanda: estabelecimento.comanda.numero,
            },
          })
          .then(({ data }) => {
            setConfig(data)
          })
          .catch((e) => {
            sentryError.exception('Erro ao carregar configurações da comanda')
          })
      }

      function setConfig(config) {
        const { hash, utilizado } = config
        estabelecimento.comanda.ativo = true
        estabelecimento.comanda.hash = hash
        estabelecimento.comanda.utilizada = utilizado

        if (!utilizado) {
          storage.setItem('hashLocal', hash)
          estabelecimento.comanda.hashLocal = hash
        } else {
          const hashLocal = storage.get('hashLocal')
          estabelecimento.comanda.hashLocal = hashLocal

          const hashAutorizado = storage.get('hashLocal-autorizado')
          if (hashAutorizado) {
            estabelecimento.comanda.hashAutorizado = hashAutorizado
            estabelecimento.comanda.hashLocal = hashAutorizado
          }
        }

        conectarSocketOlivo()
      }
    } else {
      conectarSocketOlivo()
    }

    if (estabelecimento.qrCode.ativo && estabelecimento.qrCode.modoTablet) {
      document.body.classList.add('modo-tablet')

      const mesaMenuTitle = select('.mesa-container h1')

      if (!estabelecimento.qrCode.mesa) {
        // já existe
        const alreadyExists = select('.tablet-escolher-mesa')
        if (alreadyExists) {
          return
        }

        const containerEscolherMesa = createElement(
          'div',
          {
            class:
              'tablet-escolher-mesa bg-white fixed font-20 font-500 gap-16 inset-0 p-12 tablet-escolher-mesa z-index-max',
          },
          `
                <div class="flex-center flex-column h-100 gap-16" style="max-width: 43rem;margin: auto;">
                    <img src="./images/mesa.png" class="w-100" style="max-width: 20rem;margin-bottom: 1rem;">
                    <div style="margin-bottom: 5rem;">Informe o número da mesa</div>
                    <input type="number" id="numero-mesa" class="input text-center" placeholder="Mesa">
                    <span id="error" class="font-red font-14 empty-hiddem"></span>
                    <button class="hover-bg-blue cursor-pointer btn-primary-blue font-14 font-600 w-100">Confirmar</button>
                </div>`,
        )

        document.body.appendChild(containerEscolherMesa)

        const input = select('#numero-mesa', containerEscolherMesa)
        const button = select('button', containerEscolherMesa)
        const error = select('#error', containerEscolherMesa)

        button.addEventListener('click', () => {
          error.innerHTML = ''

          let mesa = input.value
          if (mesa) {
            if (mesa < 10 && mesa.length == 1) {
              mesa = '0' + mesa
            }

            estabelecimento.qrCode.mesa = mesa
            localStorage.setItem('mesa-tablet', mesa)
            containerEscolherMesa.remove()

            mesaMenuTitle.textContent = `Mesa ${mesa}`

            toast('Mesa definida com sucesso!')
          } else {
            error.innerHTML = 'Informe o número da mesa'
          }
        })
      }

      checkCameraPermission()
    }
  } catch (e) {
    console.error(e)
  }
}

function configuraFacebookPixel() {
  if (estabelecimento.pixelFacebook) {
    const script = document.createElement('script')
    script.innerHTML = estabelecimento.pixelFacebook

    document.head.appendChild(script)

    script.onload = function () {
      try {
        fbq('track', 'PageView')
      } catch (e) {
        console.error('Erro ao rastrear a PageView:', e)
      }
    }

    script.onerror = function () {
      console.error('Erro ao carregar o script do Facebook Pixel.')
    }
  }
}

function dialog(object) {
  const dialogEl = document.createElement('div')
  dialogEl.classList = 'dialog'
  dialogEl.innerHTML = `
         <div class="dialog-background" ></div>
         <div class="dialog-container ${object.classList ? object.classList : ''
    }">
             <header>
                <span>${object.title}</span>
                ${object.close
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      : ''
    }
            </header>
            <div>${object.body}</div>
        </div>`
  const dialogContainer = select('#dialog')
  dialogContainer.appendChild(dialogEl)

  $('#dialog header svg').on('click', () => {
    dialogContainer.innerHTML = ''
  })

  if (object.function) {
    object.function()
  }
}

function exibeMensagemTax() {
  if (estabelecimento.entregaGratis && !estabelecimento.qrCode.ativo) {
    const msgEntregaGratis = document.createElement('div')
    msgEntregaGratis.innerHTML = `
        <div class="mensagem-estab-taxaentrega"> 
            <div class="mensagem-estab-taxaentrega--content">Pedidos a partir de ${format.money(estabelecimento.entregaGratis)} entrega grátis</div> 
            <div class="mensagem-estab-taxaentrega--close">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.9175 1.34381L1.91748 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.91748 1.34381L13.9175 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>                   
        </div>`
    const wrapper = select('.mensagem-estab-taxaentrega-wrapper')
    wrapper && wrapper.appendChild(msgEntregaGratis)
    wrapper
      .querySelector('.mensagem-estab-taxaentrega--close')
      .addEventListener('click', () => {
        msgEntregaGratis.remove()
      })
  }
}

try {
  axios
    .get(getUrlAction('Home', 'GetFaixaMesas'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(function ({ data }) {
      const loader = select('.app-loader')
      loader && loader.remove()

      if (data && Array.isArray(data) && data.length > 0) {
        let numeroInicial
        let numeroFinal

        data.forEach((faixa) => {
          if (!numeroInicial && !numeroFinal) {
            numeroInicial = faixa.NumeroMesaInicial
            numeroFinal = faixa.NumeroMesaFinal
          } else {
            if (faixa.NumeroMesaInicial < numeroInicial) {
              numeroInicial = faixa.NumeroMesaInicial
            }

            if (faixa.NumeroMesaFinal > numeroFinal) {
              numeroFinal = faixa.NumeroMesaFinal
            }
          }
        })

        estabelecimento.faixamesa = {
          NumeroMesaInicial: numeroInicial,
          NumeroMesaFinal: numeroFinal,
        }
      }
    })
    .catch(function (error) {
      const errorName = (error.name || '').replace(' ', '').toLowerCase()
      if (errorName != 'networkerror') {
        throw new Error(estabelecimento.urlEmpresa + ' | ' + error)
      }
    })
} catch (error) {
  const errorName = (error.name || '').replace(' ', '').toLowerCase()
  if (errorName != 'networkerror') {
    throw new Error(estabelecimento.urlEmpresa + ' | ' + error)
  }
}

if (
  window.location.href.includes('app.olivodelivery.com.br') &&
  !estabelecimento.qrCode.ativo
) {
  window.location.href = window.location.href.replace(
    'app.olivodelivery.com.br',
    'app.mogomenu.com.br',
  )
}

function configuraQRCode() {
  if (
    estabelecimento.qrCode.ativo &&
    !estabelecimento.qrCode.modoSenha &&
    isDebug
  ) {
    // let button = document.createElement('div')
    // button.classList = 'item btn-ripple debugg'
    // button.innerHTML = `
    // <div class="iconEtext">
    //     <div class="icon-menu">
    //         <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    //             <path fill-rule="evenodd" clip-rule="evenodd" d="M21 0.750015C21 0.474442 20.8489 0.221064 20.6064 0.0901094C20.3642 -0.0406938 20.0691 -0.0277871 19.8387 0.122832C19.792 0.152107 19.7446 0.180464 19.6969 0.208077C19.5913 0.26909 19.4278 0.359458 19.2071 0.469541C18.7659 0.689713 18.0964 0.988665 17.2054 1.28941C15.4244 1.8906 12.7554 2.50002 9.25 2.50002H8.7548L8.75 2.5H5.5C2.46243 2.5 0 4.96243 0 8C0 10.5176 1.6915 12.64 4 13.293V13.75C4 16.8113 4.68398 19.2548 5.06118 20.3712C5.30061 21.0798 5.96462 21.5 6.66124 21.5H8.67422C9.96801 21.5 10.7734 20.1784 10.4059 19.0465C9.99454 17.7795 9.5 15.7792 9.5 13.5C9.5 13.4701 9.49826 13.4407 9.49486 13.4118C12.8766 13.4403 15.4602 14.0559 17.1978 14.6634C18.0879 14.9745 18.7568 15.2839 19.1977 15.5117C19.2815 15.5551 19.3691 15.6077 19.4594 15.6619C19.8164 15.8764 20.2163 16.1166 20.601 15.9128C20.8465 15.7828 21 15.5278 21 15.25V0.750015ZM9.5 11.9118C13.0638 11.9409 15.8127 12.5901 17.6928 13.2474C18.4304 13.5053 19.0339 13.7642 19.5 13.9872V1.99271C19.033 2.20875 18.427 2.46022 17.6852 2.71062C15.8068 3.34467 13.0605 3.97086 9.5 3.99903V11.9118ZM5.5 13.75V13.5H8C8 15.9857 8.53723 18.1484 8.97923 19.5098C9.01459 19.6187 8.99563 19.7471 8.92328 19.8533C8.85291 19.9566 8.76098 20 8.67422 20H6.66124C6.55594 20 6.49953 19.9421 6.48225 19.891C6.13816 18.8726 5.5 16.5974 5.5 13.75ZM5.5 4H8V12H5.5C3.29086 12 1.5 10.2091 1.5 8C1.5 5.79086 3.29086 4 5.5 4Z" fill="#24292E"/>
    //         </svg>
    //     </div>
    //     <div class="text">
    //         <div>Chamar um garçom</div>
    //         <div class="detalhe">Um garçom virá até você</div>
    //     </div>
    // </div>
    // <div class="seta">
    //     <svg viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M1 1L8 8L1 15" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
    //     </svg>
    // </div>
    // `

    // button.addEventListener('click', () => {
    //     if (estabelecimento.comanda.ativo) {
    //         //Foi feito apenas para o Regelli que é em anexo ao Regente Hotel
    //         let isRegente = localStorage.getItem('urlEmpresa') == 'regente'

    //         dialog({
    //             title: `${isRegente ? 'Quarto/Mesa' : 'Mesa'}`,
    //             classList: 'dialog-mesa',
    //             body: `
    //             <span>${isRegente ? 'Qual é o número do quarto ou mesa?' : 'Qual é o número da mesa?'}</span>
    //             <input id="numero-mesa" type="number" placeholder="${isRegente ? 'Quarto/Mesa' : 'Mesa'}" class="input" required />
    //             <div class="flex">
    //                 <button class="btn btn-seccondary small">Voltar</button>
    //                 <button class="btn btn-primary small">Confirmar</button>
    //             </div>`,
    //             function: () => {
    //                 let mesaAssociada = localStorage.getItem('mesa-associada')

    //                 if (mesaAssociada) {
    //                     let inputMesa = select('#numero-mesa')
    //                     if (inputMesa) {
    //                         inputMesa.value = mesaAssociada
    //                     }
    //                 }
    //                 select('.dialog-mesa .btn-seccondary').addEventListener(
    //                     'click',
    //                     () => {
    //                         select('#dialog').innerHTML = ''
    //                     }
    //                 )
    //                 select('.dialog-mesa .btn-primary').addEventListener(
    //                     'click',
    //                     () => {
    //                         let strMesa = select('#numero-mesa').value

    //                         if (!strMesa) {
    //                             toast('Digite o número da mesa antes de continuar.')
    //                         } else {
    //                             let numberMesa = Number(strMesa)
    //                             if (
    //                                 estabelecimento.faixamesa &&
    //                                 numberMesa <
    //                                 estabelecimento.faixamesa.NumeroMesaInicial ||
    //                                 numberMesa >
    //                                 estabelecimento.faixamesa.NumeroMesaFinal
    //                             ) {
    //                                 toast('Mesa não encontrada.')
    //                             } else {
    //                                 if (Number(strMesa) < 10 && strMesa.length == 1) {
    //                                     strMesa = '0' + strMesa
    //                                 }

    //                                 toast('Chamando um garçom...')
    //                                 chamaGarcon(strMesa)
    //                                 let background = select('.menu-background')
    //                                 background && background.click()
    //                                 select('#dialog').innerHTML = ''
    //                             }
    //                         }
    //                     }
    //                 )
    //             }
    //         })
    //     } else {
    //         toast('Chamando um garçom...')
    //         chamaGarcon()
    //         let background = select('.menu-background')
    //         background && background.click()
    //     }
    // })

    // let menuList = select('.menu .itens')
    // menuList.appendChild(button)

    const tutorial = storage.get('tutorial-garcon')

    if (!tutorial && !estabelecimento.qrCode.apenasVisualizacao) {
      // //Cria o elemento com a classe para criar o fundo opaco e escuro
      // let wrapper = document.createElement('div')
      // wrapper.classList.add('tutorial-garcon')

      // wrapper.innerHTML = `
      // <div class="tutorial-garcon-message">
      //     Sempre que precisar, você pode chamar um garçom acessando o menu
      // </div>
      // <div>Toque em qualquer lugar para continuar</div> `

      // //cria a função que remove o fundo apoós qualquer click
      // let listenerDocument = () => {
      //     wrapper.remove()
      //     document.removeEventListener('click', listenerDocument)
      // }

      // document.addEventListener('click', listenerDocument)

      const searchArea = select('#search-area')
      const navBar = select('#nav-bar')
      navBar.insertBefore(wrapper, searchArea)

      localStorage.setItem('tutorial-garcon', true)
    }
  }
}

function chamaGarcon(strMesa) {
  axios
    .get(getUrlAction('home/ChamaGarcon'), {
      params: {
        mesa: strMesa || estabelecimento.mesa,
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then((response) => {
      console.log(response)
    })
    .catch((error) => {
      console.log(error)
    })
}

export { estabelecimento }

function removeLoaderApp() {
  const loader = select('.app-loader')
  loader && loader.remove()
}

function defineTempoEntrega() {
  try {
    if (estabelecimento.tempoEntrega) {
      estabelecimento.descricaoTempoEntrega = estabelecimento.tempoEntrega
      estabelecimento.tempoEntrega = estabelecimento.tempoEntrega.split('-')

      if (estabelecimento.tempoEntrega.length > 0) {
        if (estabelecimento.tempoEntrega[0]) {
          estabelecimento.tempoEntrega[0] =
            estabelecimento.tempoEntrega[0].replace(/\D/gim, '')
        }

        if (estabelecimento.tempoEntrega[1]) {
          estabelecimento.tempoEntrega[1] =
            estabelecimento.tempoEntrega[1].replace(/\D/gim, '')
        }

        if (estabelecimento.tempoEntrega[0] == '') {
          estabelecimento.tempoEntrega = undefined
        }
      }
    }
  } catch (e) {
    sentryError.exception(estabelecimento.urlEmpresa + ' - ' + e)
  }
}

function defineRedesSociais(data) {
  const iconeTwitter = select('#twitter')
  const iconeFacebook = select('#facebook')
  const iconeInstagram = select('#instagram')

  if (data.contato.instagram && iconeInstagram) {
    iconeInstagram.setAttribute('href', data.contato.instagram)
  } else {
    iconeInstagram && iconeInstagram.remove()
  }

  if (data.contato.facebook && iconeFacebook) {
    iconeFacebook.setAttribute('href', data.contato.facebook)
  } else {
    iconeFacebook && iconeFacebook.remove()
  }

  if (data.contato.twitter && iconeTwitter) {
    iconeTwitter.setAttribute('href', data.contato.twitter)
  } else {
    iconeTwitter && iconeTwitter.remove()
  }
}

function carregaPedidoLocalStorage() {
  // Carrega o pedido armazenado no storage
  const pedido = storage.get(`pedido-mobile-${estabelecimento.urlEmpresa}`)
  const configuracoesPagamentoQRCode = pedido?.configuracoesPagamentoQRCode
  delete pedido?.configuracoesPagamentoQRCode

  if (pedido) {
    const dataPedido = new Date(
      (pedido.Itens[0].CodTicks - 621355968000000000) / 10000,
    )
    const diferencaTempo = new Date().getTime() - dataPedido.getTime()
    if (diferencaTempo / (1000 * 60 * 60) > 5) {
      storage.remove(`pedido-mobile-${estabelecimento.urlEmpresa}`)
    } else {
      for (const key in pedido) {
        storeOrder[key] = pedido[key]
      }

      if (configuracoesPagamentoQRCode) {
        exibeQrCodePIX(
          configuracoesPagamentoQRCode.linkImagemPix,
          configuracoesPagamentoQRCode,
        )
      } else {
        showButtonOrder(true)
      }
    }
  }
}

function configuraCabecalhoEstabelecimento() {
  const logo = select('#cardapio .logo-container img')
  if (logo) {
    logo.setAttribute('src', estabelecimento.logo)
    logo.classList = ''
  }

  const fantasiaText = select('#estabelecimento-fantasia')
  fantasiaText && (fantasiaText.textContent = estabelecimento.fantasia)

  const tempoEntregaWrapper = select('#estabelecimento-entrega')
  if (
    estabelecimento.descricaoTempoEntrega &&
    tempoEntregaWrapper &&
    !estabelecimento.qrCode.ativo
  ) {
    tempoEntregaWrapper.innerHTML = `
        <div class="u-flex-column u-flex-start u-margin-r-1">
            <div class="u-nowrap u-font-gray-dark u-font-12">Entrega</div>
            <div class="u-font-gray-dark u-font-12 u-font-w-450">${estabelecimento.descricaoTempoEntrega}</div>
        </div>`
  }

  if (estabelecimento.endereco.cidade) {
    const enderecoText = select('#estabelecimento-endereco')
    enderecoText &&
      (enderecoText.textContent =
        estabelecimento.endereco.cidade +
        (estabelecimento.endereco.estado
          ? ', ' + estabelecimento.endereco.estado.toUpperCase()
          : ''))
  }
}

axios.get('https://api.ipify.org?format=json').then(({ data }) => {
  try {
    estabelecimento.ip = data.ip
  } catch (e) {
    sentryError.exception(e)
  }
})

function verificaCardapioLeitura() {
  const ticks = storage.get('cardapio-leitura')
  if (ticks) {
    // verifica se o acesso é nas ultimas 12 horas
    if (new Date(ticks).getTime() + 43200000 > new Date().getTime()) {
      return true
    } else {
      storage.remove('cardapio-leitura')
      return false
    }
  } else {
    return false
  }
}
